var map = {
	"./Stage_1_Diff.jpg": "e508",
	"./Stage_2_Diff.jpg": "3715",
	"./Stage_3_Diff.jpg": "f6c3",
	"./Stage_4_Diff.jpg": "6686",
	"./Stage_5_Diff.jpg": "24e5",
	"./Stage_6_Diff.jpg": "e22e",
	"./Stage_7_Diff.jpg": "dea8",
	"./Stage_8_Diff.jpg": "81b8",
	"./Stage_9_Diff.jpg": "cce1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d2d1";